const _brl0 = new Intl.NumberFormat('pt-BR', { style:'currency', currency:'BRL', maximumFractionDigits:0 });
const _brlCache = new Map();
function _brlFmt(dec) {
  if (!_brlCache.has(dec))
    _brlCache.set(dec, new Intl.NumberFormat('pt-BR', { style:'currency', currency:'BRL', minimumFractionDigits:dec, maximumFractionDigits:dec }));
  return _brlCache.get(dec);
}
const _num  = new Intl.NumberFormat('pt-BR', { minimumFractionDigits:1, maximumFractionDigits:2 });
const _num2 = new Intl.NumberFormat('pt-BR', { minimumFractionDigits:2, maximumFractionDigits:2 });

export function fmtBRL(v, dec = 2) {
  if (v == null) return '—';
  return _brlFmt(dec).format(v);
}
// Iguais a fmtBRL, mas sem o símbolo "R$" — usados em tabelas/gráficos onde a
// unidade já vira subtítulo/coluna do cabeçalho (ex. aba Carteira — ver
// PAINEL_UNIT_SUB em Painel2.jsx e CarteiraValue.jsx — e a tabela de
// Validação de PU, cujas colunas já trazem "R$" abaixo do título), em vez de
// repetir o símbolo em toda célula.
export function fmtNum2(v) {
  if (v == null) return '—';
  return v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
export function fmtNum8(v) {
  if (v == null) return '—';
  return v.toLocaleString('pt-BR', { minimumFractionDigits: 8, maximumFractionDigits: 8 });
}
// Divide uma string já formatada (pt-BR, decimal por vírgula) em [prefixo até
// `casas` decimais, resto das decimais] — usado pra destacar visualmente só as
// casas decimais que entram numa tolerância (ex. Validação de PU, que só
// considera as 3 primeiras casas — ver PU_DIFF_CASAS em puValidacaoModel.js).
export function splitCasasDestaque(formatted, casas = 4) {
  if (!formatted) return [formatted, ''];
  const i = formatted.indexOf(',');
  if (i === -1) return [formatted, ''];
  const decimais = formatted.slice(i + 1);
  return [formatted.slice(0, i + 1) + decimais.slice(0, casas), decimais.slice(casas)];
}
export function fmtPct(frac) {
  if (frac == null) return '—';
  return _num.format(frac * 100) + '%';
}
export function fmtCompact(v) {
  if (v == null) return '—';
  const abs = Math.abs(v);
  if (abs >= 1e9) return 'R$ ' + _num.format(v/1e9) + ' bi';
  if (abs >= 1e6) return 'R$ ' + _num.format(v/1e6) + ' mi';
  if (abs >= 1e3) return 'R$ ' + Math.round(v/1e3) + ' mil';
  return _brl0.format(v);
}
export function fmtValor(tipo_valor, v) {
  if (v == null) return '—';
  return tipo_valor === 'reais' ? fmtBRL(v, 0) : fmtPct(v);
}
// Igual a fmtValor, mas sem o símbolo (R$/%) — usado em rótulos de gráfico, onde o
// eixo/legenda já deixa claro a unidade e o símbolo repetido em cada barra só poluiria.
export function fmtLabelShort(tipo_valor, v) {
  if (v == null) return '';
  return tipo_valor === 'reais' ? fmtCompact(v).replace('R$ ', '') : fmtPct(v).replace('%', '');
}
export function fmtRefLabel(ind) {
  if (ind.ref != null && ind.tipo_ref != null) {
    const pre = ind.tipo_ref === 'min' ? 'mín.' : 'máx.';
    return pre + ' ' + fmtValor(ind.tipo_valor, ind.ref);
  }
  // Fundo de Obras não tem min/max de enquadramento — "remanescente_obra" é só o
  // saldo que ainda falta gastar com a obra, exibido como referência informativa.
  if (ind.remanescente_obra != null) return 'rem.' + fmtValor(ind.tipo_valor, ind.remanescente_obra);
  return 'Sem referência';
}
// Rótulo da linha de referência nos cards de indicador — "Remanescente" só no caso
// do Fundo de Obras (sem min/max, só o saldo que falta gastar); os demais fundos/
// índices continuam com "Referência".
export function fmtRefFieldLabel(ind) {
  return (ind.ref == null && ind.remanescente_obra != null) ? 'Remanescente' : 'Referência';
}
// Versão com duas casas decimais fixas (usada no card de detalhe do indicador, aberto
// ao clicar num valor) — a célula da tabela continua compacta/sem decimais.
export function fmtPctPreciso(frac) {
  if (frac == null) return '—';
  return _num2.format(frac * 100) + '%';
}
export function fmtValorPreciso(tipo_valor, v) {
  if (v == null) return '—';
  return tipo_valor === 'reais' ? fmtBRL(v, 2) : fmtPctPreciso(v);
}
export function fmtRefLabelPreciso(ind) {
  if (ind.ref == null || ind.tipo_ref == null) return 'Sem referência';
  const pre = ind.tipo_ref === 'min' ? 'mín.' : 'máx.';
  return pre + ' ' + fmtValorPreciso(ind.tipo_valor, ind.ref);
}
const MES_LABEL = ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'];
export function periodLabel(period) {
  if (!period) return '';
  const m = parseInt(String(period).slice(4, 6), 10) - 1;
  return MES_LABEL[m] + '/' + String(period).slice(0, 4);
}
